import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const WA_DEFAULT = 'https://wa.me/971585338786?text=Hi%20I%20am%20interested%20in%20buying%20or%20selling%20an%20e-bike';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/buy', label: 'Buy E-Bikes' },
  { to: '/sell', label: 'Sell Your Bike' },
  { to: '/surron-dubai', label: 'Surron' },
  { to: '/talaria-dubai', label: 'Talaria' },
  { to: '/electric-scooters-dubai', label: 'Scooters' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav style={{ background: 'rgba(10,10,10,0.95)', borderBottom: '1px solid var(--dark-4)', position: 'sticky', top: 0, zIndex: 100, backdropFilter: 'blur(20px)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--volt)"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
          <span style={{ fontFamily: "'Space Grotesk'", fontWeight: 700, fontSize: 18, color: 'var(--text)' }}>
            eBike<span style={{ color: 'var(--volt)' }}>Dubai</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hide-mobile" style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
          {NAV_LINKS.slice(0, 6).map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
              style={{ textDecoration: 'none' }}
            >
              {link.label}
            </Link>
          ))}
          <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button className="btn-wa btn-sm">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg>
              WhatsApp
            </button>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="show-mobile" onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', color: 'var(--text)', cursor: 'pointer', padding: 8 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" fill="none">
            {menuOpen ? <path d="M18 6L6 18M6 6l12 12"/> : <path d="M3 12h18M3 6h18M3 18h18"/>}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="show-mobile" style={{ background: 'var(--dark-2)', borderTop: '1px solid var(--dark-4)', padding: 16 }}>
          {NAV_LINKS.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
              style={{ display: 'block', padding: '12px 0', textDecoration: 'none' }}
            >
              {link.label}
            </Link>
          ))}
          <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'block', marginTop: 12 }}>
            <button className="btn-wa" style={{ width: '100%', justifyContent: 'center' }}>WhatsApp Us</button>
          </a>
        </div>
      )}
    </nav>
  );
}
